// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import constants from "@store/constants";
import StyleguideComponent from "@store/Library/Components/Toolkit/Styleguide";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import React, { FC } from "react";

export interface StyleguideProps extends WidgetProps {}

export interface StyleguideStyles {
    editModeText?: TypographyPresentationProps;
}

export const styleguideStyles: StyleguideStyles = {
    editModeText: typographyGetNoResultsAltProps(),
};

const styles = styleguideStyles;

const Styleguide: FC<StyleguideProps> = () => {
    const { isEditing } = useShellContext();

    if (isEditing) {
        return <Typography {...styles.editModeText}>Exit edit mode to view the styleguide</Typography>;
    }

    return <StyleguideComponent />;
};

const widgetModule: WidgetModule = {
    component: Styleguide,
    definition: {
        group: constants.widgetGroup.styleguide,
        canAdd: x => x.permissions?.canEditGlobalStyleGuide || false, // CMS_SystemAdmin
    },
};

export default widgetModule;
